import { useEffect, useRef, useState } from 'react'

export default function usePreviousValue<T>(value: T): T | undefined {
  const [lastValue, setLastValue] = useState<T>()

  useEffect(() => {
    if (value) setLastValue(value)
  }, [value])

  return lastValue
}
